/**
 * Tabla del backoffice, con su desplazamiento horizontal propio.
 *
 * El contenedor scrollea en vez de dejar que la tabla empuje la pagina entera:
 * en un notebook una tabla de ocho columnas se sale, y lo que no puede pasar es
 * que se salga el sitio.
 *
 * Lleva `tabIndex` para que el area desplazable se pueda recorrer con el
 * teclado, que es lo que exige una region con scroll.
 */
import type { ReactNode } from 'react';

export interface TablaProps {
  /** Que lista la tabla; se anuncia y se muestra solo a lector de pantalla. */
  titulo: string;
  encabezados: ReactNode;
  children: ReactNode;
}

export function Tabla({ titulo, encabezados, children }: TablaProps) {
  return (
    <div className="env-tabla" tabIndex={0} role="region" aria-label={titulo}>
      <table className="tabla">
        <caption className="solo-lectores">{titulo}</caption>
        <thead>
          <tr>{encabezados}</tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
